import i18next from 'i18next'
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'

export const LanguageNames = {
  hiragana: 'ひらがな',
  kanji: '漢字',
} as const
const Languages = Object.keys(LanguageNames)
export type LanguageTypes = (typeof Languages)[number]

export class Translation {
  constructor() {
    i18next.use(i18nextBrowserLanguageDetector).init()
  }

  isAvailable = (name: string): name is LanguageTypes => {
    return Languages.some((value) => value === name)
  }

  get language(): LanguageTypes {
    return this.isAvailable(i18next.language) ? i18next.language : 'hiragana'
  }

  set language(lang: LanguageTypes) {
    i18next.changeLanguage(lang).catch()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  to(key: keyof this, substitutions?: Array<any>): string {
    const keyObject = this[key] as Record<LanguageTypes, string>
    let translation = keyObject[this.language] as string
    if (substitutions) {
      substitutions.forEach((substitution, index) => {
        translation = translation.replace(
          new RegExp(`%${index + 1}`, 'g'),
          substitution.toString(),
        )
      })
    }
    return translation
  }
}
